import React, { FC } from 'react';
import { ReactComponent as ConnectWalletIcon } from '@blink/assets/src/icons/connectWallet.svg';

import { useUserVaultsStyle } from '../UserVaults.style';

export const UserVaultsConnectWallet: FC = () => {
    const commonClasses = useUserVaultsStyle();

    return (
        <div className={commonClasses.noSuppliesBlock}>
            <ConnectWalletIcon />
            <div className={commonClasses.noSuppliesTitle}>Please, connect your wallet</div>
            <div className={commonClasses.noSuppliesSubtitle}>
                Please connect your wallet to see your supplies, borrowings, and open positions
            </div>
        </div>
    );
};
